import React from "react";
import prop from "ramda/src/prop";
import sortBy from "ramda/src/sortBy";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { Button } from "../../UI/Button";
import { EnhancedTable } from "../EnhancedTable";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { useNetwork } from "../../hooks/useNetwork";
import { useModalContext } from "../../contexts/ModalContext/context";
import { ModalProvider } from "../../contexts/ModalContext";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { Grid } from "../../UI/Grid";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { TableCell } from "../../UI/TableCell";
import { GenderOptionsTableRow } from "./GenderOptionsTableRow";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  subnetwork: number;
  isDisabled?: boolean;
}

export const GenderOptionsTable: React.FC<IProps> = (props) => {
  const { getL2, selectedNetwork } = useNetwork();
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const l2 = getL2(selectedNetwork.l1Id, props.subnetwork);

  const handleAddGender = () => {
    setIsOpen(true);
  };

  const genders = l2?.genderNetworkSettingsTransport.genders || [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <EnhancedTable
          title="Gender Options"
          titleHelpTooltip="You can create up to 50 Gender Options. Each must be associated to a group for matching purposes."
        >
          <TableHead secondary>
            <TableRow>
              <TableCell>Gender Option</TableCell>
              <TableCell>Gender Group </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <EnhancedTableBody colSpan={3}>
            {sortBy(prop("id"), genders).map((gender) => (
              <ModalProvider key={gender.id}>
                <GenderOptionsTableRow {...gender} subnetwork={props.subnetwork} isDisabled={props.isDisabled}/>
              </ModalProvider>
            ))}
          </EnhancedTableBody>
        </EnhancedTable>
      </Grid>
      <Grid item xs={12}>
        <ReadOnlyWrapper>
          <Button 
            appearance="primary"
            onClick={handleAddGender}
            iconBefore={<EditorAddIcon label="Plus" />}
            isDisabled={isSuperAdminRead() || props.isDisabled}
          >
            Add Gender Option
          </Button>
        </ReadOnlyWrapper>
      </Grid>
    </Grid>
  );
};
